import type { Direction } from '@wix/editor-elements-common-utils';
import { convertPhysicalAlignmentToLogical } from '@wix/editor-elements-common-utils';
import type { IShareButtonsMapperProps } from '../types';

export const migrateAlign = (
  legacyAlign:
    | IShareButtonsMapperProps['alignmentDirection']
    | undefined = 'left',
  legacyDirection: Direction | undefined = 'ltr',
) => convertPhysicalAlignmentToLogical(legacyAlign, legacyDirection);
